import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";

export default function CheckingAuthDialog({ open = true }) {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 320,
          p: 1,
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            py: 2,
          }}
        >
          <CircularProgress size={40} sx={{ color: "#003376" }} />
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#003376" }}>
            Checking authentication…
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we verify your session
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
